import { TAG_TYPES } from '@/lib/api/tags';
import { processServerError } from '@/lib/api/listQuery';
import { notifyOnSuccess } from '@/lib/api/notifyOnSuccess';
import { buildCompanyProfileDto } from '../mappers/accountSetupMappers';

const PATHS = {
  account: '/account',
};

export const accountSetupEndpoints = (build) => ({
  updateCompanyProfile: build.mutation({
    query: (values) => ({
      url: PATHS.account,
      method: 'PATCH',
      body: buildCompanyProfileDto(values),
    }),
    transformErrorResponse: processServerError,
    onQueryStarted: notifyOnSuccess('ACCOUNT_SETUP_COMPANY_PROFILE_SAVED_FLASH'),
    invalidatesTags: [TAG_TYPES.Session],
  }),
});
